/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notes_No_Link_BodyInputs */



/**
* | output |
* | --- |
* | "This meeting has no online meeting link, so Wundo cannot sit in." |
*
* @param {Meeting_Notes_No_Link_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notes_no_link_body = /** @type {((inputs?: Meeting_Notes_No_Link_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notes_No_Link_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Deze meeting heeft geen online vergaderlink, dus Wundo kan niet aansluiten.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette réunion n'a pas de lien de visioconférence, donc Wundo ne peut pas la rejoindre.")
	return /** @type {LocalizedString} */ ("This meeting has no online meeting link, so Wundo cannot sit in.")
});